import {MatTooltipModule} from '@angular/material/tooltip';
import { ModalHelpModule } from './../modal-help/modal-help.module';
import { RouterModule } from '@angular/router';
import { HeaderMenuComponent } from './header-menu.component';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverHelpModule } from '../popover-help/popover-help.module';

@NgModule({
    declarations: [HeaderMenuComponent],
    exports: [HeaderMenuComponent],
    imports: [
        CommonModule,
        IonicModule,
        RouterModule,
        ModalHelpModule,
        MatTooltipModule,
        PopoverHelpModule
    ]
})
export class HeaderMenuModule { }
